// Source rectangles measured from the original imagegen PNGs; no bitmap was modified.
// Frames cross nominal row boundaries, so crop actual silhouettes instead of a uniform grid.
export const ATLAS = {
  "goblins": [
    [
      48,
      32,
      236,
      247
    ],
    [
      352,
      29,
      238,
      264
    ],
    [
      665,
      29,
      239,
      250
    ],
    [
      968,
      29,
      240,
      264
    ],
    [
      56,
      331,
      230,
      257
    ],
    [
      355,
      331,
      233,
      267
    ],
    [
      667,
      331,
      232,
      257
    ],
    [
      973,
      331,
      232,
      267
    ],
    [
      91,
      637,
      166,
      273
    ],
    [
      391,
      638,
      163,
      272
    ],
    [
      698,
      638,
      159,
      272
    ],
    [
      1001,
      638,
      160,
      270
    ],
    [
      96,
      944,
      162,
      274
    ],
    [
      383,
      942,
      173,
      275
    ],
    [
      700,
      943,
      163,
      274
    ],
    [
      1005,
      943,
      165,
      274
    ]
  ],
  "enemies": [
    [
      55,
      44,
      203,
      235
    ],
    [
      370,
      44,
      195,
      248
    ],
    [
      690,
      44,
      194,
      248
    ],
    [
      998,
      47,
      200,
      232
    ],
    [
      63,
      351,
      198,
      237
    ],
    [
      378,
      351,
      201,
      244
    ],
    [
      686,
      351,
      206,
      247
    ],
    [
      989,
      327,
      234,
      269
    ],
    [
      44,
      636,
      221,
      261
    ],
    [
      365,
      636,
      207,
      269
    ],
    [
      682,
      636,
      208,
      269
    ],
    [
      994,
      628,
      223,
      273
    ],
    [
      23,
      950,
      269,
      260
    ],
    [
      332,
      950,
      273,
      270
    ],
    [
      650,
      949,
      272,
      271
    ],
    [
      968,
      914,
      260,
      303
    ]
  ],
  "props": [
    [
      18,
      81,
      284,
      252
    ],
    [
      325,
      160,
      293,
      153
    ],
    [
      669,
      45,
      237,
      297
    ],
    [
      949,
      45,
      290,
      292
    ],
    [
      20,
      399,
      281,
      250
    ],
    [
      371,
      375,
      199,
      275
    ],
    [
      642,
      413,
      284,
      233
    ],
    [
      967,
      410,
      263,
      241
    ],
    [
      13,
      742,
      299,
      145
    ],
    [
      318,
      743,
      308,
      144
    ],
    [
      633,
      705,
      307,
      186
    ],
    [
      940,
      709,
      224,
      188
    ],
    [
      34,
      948,
      256,
      266
    ],
    [
      325,
      1035,
      294,
      64
    ],
    [
      739,
      910,
      131,
      320
    ],
    [
      949,
      933,
      289,
      285
    ]
  ]
} as const;
